import { render } from "./recording.vue?vue&type=template&id=1d610a1c&scoped=true"
import script from "./recording.vue?vue&type=script&lang=js"
export * from "./recording.vue?vue&type=script&lang=js"

import "./recording.vue?vue&type=style&index=0&id=1d610a1c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d610a1c"

export default script